<template>
<div v-if="active" class="loading-container">
  <div class="loading-main">
    <div class="loading-animation">
      <div class="dot dot-1"></div>
      <div class="dot dot-2"></div>
      <div class="dot dot-3"></div>
    </div>
    <div class="loading-overlay">        
    </div>
    <div class="loading-message">      
      <span v-if="!longWait">{{ defaultMessage }}</span>
      <span v-else>{{ altMessage }}</span>   
    </div>
  </div>      

  <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7"/>
      </filter>
    </defs>
  </svg>
</div>  
</template>

<script>
export default {
  name: 'TSLoading',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    defaultMessage: {
      type: String,
      default: null
    },
    altMessage: {
      type: String,
      default: null
    },
  },
  watch: {
    active: function (val) {
      if (val) {
        this.startTimeOut();
      } else {
        this.endTimeOut();
      }
    }
  },
  updated() {
    this.changeTextColor();
  },
  data() {
    return {
      longWait: false,
      timer: null,
      colorWait: false,
      colorTimer: null,
    };
  },
  methods: {
    startTimeOut() {
      clearTimeout(this.timer);
      if (!this.longWait) {
        this.timer = setTimeout(this.changeText, 10000);
      } else {
        this.timer = setTimeout(this.changeText, 5000);
      }      
    },
    endTimeOut() {
      clearTimeout(this.timer);
    },
    changeText() {
      this.longWait = !this.longWait;
      this.startTimeOut();
    },
    startTextTimeOut() {
      clearTimeout(this.colorTimer);
      this.colorTimer = setTimeout(this.changeTextColor, 1000);
    },
    changeTextColor() {        
      var target = document.getElementsByClassName('loading-message'); 
      if(target.length == 0) return false;

      this.colorWait = !this.colorWait;  
      if (!this.colorWait) {
        target[0].style.color = '#d2d2d2';
      } else {
        target[0].style.color = '#ffffff';
      }
      clearTimeout(this.colorTimer);
      this.startTextTimeOut();
    }
  }
};
</script>

<style scoped lang="scss">
.loading-overlay{  
  background-color: rgb(37, 37, 37);
  opacity:0.5;
  width: 100%;
  height: 100%;
  top:0;
  bottom:0;
  left:0;
  right:0;
  margin: auto;
  position: fixed;
  display: block;
  z-index:9995;
}

.loading-animation {  
  width: 50px;
  height: 50px;
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
  transform: translate(-50%, -50%);
  margin: auto;
  filter: url('#goo');
  animation: rotate-move 2s ease-in-out infinite;
  z-index:9996;
}

.loading-message {  
  width: 600px;
  height: 200px;
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
  margin: auto;
  z-index:9996;
  padding-top: 200px;
  color: #ffffff;
  text-align: center;
  font-size: 24px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.dot { 
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.dot-3 {
  background-color: #ffffff;
  //background-color: #f74d75;
  animation: dot-3-move 2s ease infinite, index 6s ease infinite;
}

.dot-2 {
  background-color: #00c8dc;
  //background-color: #10beae;
  animation: dot-2-move 2s ease infinite, index 6s -4s ease infinite;
}

.dot-1 {
  background-color: #14223c;
  //background-color: #ffe386;
  animation: dot-1-move 2s ease infinite, index 6s -2s ease infinite;
}

@keyframes dot-3-move {
  20% {transform: scale(1)}
  45% {transform: translateY(-18px) scale(.45)}
  60% {transform: translateY(-90px) scale(.45)}
  80% {transform: translateY(-90px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes dot-2-move {
  20% {transform: scale(1)}
  45% {transform: translate(-16px, 12px) scale(.45)}
  60% {transform: translate(-80px, 60px) scale(.45)}
  80% {transform: translate(-80px, 60px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes dot-1-move {
  20% {transform: scale(1)}
  45% {transform: translate(16px, 12px) scale(.45)}
  60% {transform: translate(80px, 60px) scale(.45)}
  80% {transform: translate(80px, 60px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes rotate-move {
  55% {transform: translate(-50%, -50%) rotate(0deg)}
  80% {transform: translate(-50%, -50%) rotate(360deg)}
  100% {transform: translate(-50%, -50%) rotate(360deg)}
}

@keyframes index {
  0%, 100% {z-index: 3}
  33.3% {z-index: 2}
  66.6% {z-index: 1}
}
</style>